export default {
    'add-new-team': 'إضافة فريق جديد',
    'edit-team': 'تعديل فريق'
}